<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created(){
  }
}
</script>
<style>
html,body,#app{
  height: 100%;
  box-sizing: border-box;
  margin: 0;
}
#app{
  font-family: Century Gothic ;
  white-space: pre-wrap !important;
  white-space: pre-wrap !important
}
.padding {
	width: 80%;
	margin-top: 100px;
	margin-bottom: 100px;
}
  .table-title{
    padding:10px;
    margin-bottom: 5px;
    background: linear-gradient(40deg,#ff2020, #05ffa3);
    color: #fff;
    border-radius: 1px 1px 0 0;
    box-shadow: 0 1px 1px rgba(0, 0, 0,0.247);
}
.table-title h2{
    font-size: 24px;
}
</style>
